import PropTypes from 'prop-types';
import React, { createContext, useCallback, useContext, useState } from 'react';
import { Modal } from 'rsuite';

const ModalContext = createContext(null);

export const ModalContextProvider = ({ children }) => {
  const [modalContent, setModalContent] = useState(null);
  const [modalClassName, setModalClassName] = useState(null);
  const [modalSize, setModalSize] = useState('sm');
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [cookieModalIsOpen, setCookieModalIsOpen] = useState(false);

  const onOpenModal = useCallback(() => setModalIsOpen(true), []);
  const onCloseModal = useCallback(() => setModalIsOpen(false), []);
  const onToggleModal = useCallback(() => setModalIsOpen(!modalIsOpen), [
    modalIsOpen,
  ]);

  return (
    <ModalContext.Provider
      value={{
        modalClassName,
        modalContent,
        modalIsOpen,
        modalSize,
        cookieModalIsOpen,
        setCookieModalIsOpen,
        onCloseModal,
        onOpenModal,
        onToggleModal,
        setModalClassName,
        setModalContent,
        setModalIsOpen,
        setModalSize,
      }}
    >
      {children}
      <Modal
        className={modalClassName}
        data-qa-id="modal"
        onClose={() => setModalIsOpen(false)}
        open={modalIsOpen}
        overflow={false}
        size={modalSize}
      >
        <Modal.Header />
        <Modal.Body>{modalContent}</Modal.Body>
      </Modal>
    </ModalContext.Provider>
  );
};

export const useModalContext = () => useContext(ModalContext);

ModalContextProvider.defaultProps = {};

ModalContextProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};
